import { urlFetch, parseLyric} from './Util';

const host = 'https://api.dengtongyu.com/music/netease';

const searchUrl = host + '/search';

const rankUrl = host + '/playlist/detail';

const songDetailUrl = host + '/song/detail';

const songLyriclUrl = host + '/lyric';

const songPlayUrl = host + '/song/url';

let getNeteaseSearchSongList = async function(keyWord, page, size) {
    if(!keyWord) keyWord = '';
    if(!page) page = 1;
    if(!size) size = 10;
    let offset = (page - 1)* size;
    let url = searchUrl + '?keywords=' + keyWord + '&offset=' + offset + '&limit=' + size;
    let response = await urlFetch(url);

    try {
        let data = await response.json();
        //console.log(data)
        let songs = {};
        songs.list = [];
        songs.aggregation = [];
        songs.page = 1;

        if(data.code === 200) {
            let list = data.result.songs;
            for (let index = 0; index < list.length; index++) {
                let songMsg = {};
                songMsg.Hash = list[index].id;
                songMsg.SongName = list[index].name;
                songMsg.SingerName = singersName(list[index].artists);
                songMsg.Duration = list[index].duration;
                
                songs.list.push(songMsg);
            
            }
            songs.aggregation = [];
            songs.page = page;
        }
        return songs;
    } catch (err) {
        console.error(err);
        return Promise.reject(err);
    }
}

let getNeteaseHotSongList = async function() {
    let url = rankUrl + '?id=3778678';
    let response  = await urlFetch(url);
    try {
        let data = await response.json();

        let songs = [];
        if(data.code === 200) {
            let list = data.playlist.tracks;
            for (let index = 0; index < list.length; index++) {
                let songMsg = {};
                songMsg.Hash = list[index].id;
                songMsg.SongName = list[index].name;
                songMsg.SingerName = singersName(list[index].ar);
                songMsg.Duration = list[index].dt;
        
                songs.push(songMsg);
            }
        }
        return songs;
    } catch (err) {
        console.error(err);
        return Promise.reject(err);
    }
}

let getNeteaseSongMassge = async function(hash) {
    let songMassge = {};
    let detailUrl = songDetailUrl + '?ids=' + hash;
    let detailResponse = await urlFetch(detailUrl);
    try {
        let detailJson = await detailResponse.json();

        if(detailJson.code === 200) {
            songMassge.SongName = detailJson.songs[0].name;
            songMassge.SingerName = singersName(detailJson.songs[0].ar);
            songMassge.Img = detailJson.songs[0].al.picUrl;
            songMassge.AlbumName = detailJson.songs[0].al.name;
            songMassge.Duration = Math.floor(detailJson.songs[0].dt / 1000);
            songMassge.Hash = hash;
            //songMassge.PlayUrl = getPlayUrl(hash);
        }
    } catch(err) {
        console.error(err);
        return Promise.reject(err);
    }

    let lyricUrl = songLyriclUrl + '?id=' + hash;
    let lyricResponse = await urlFetch(lyricUrl);
    try {
        let lyricJson = await lyricResponse.json();

        if(lyricJson.code === 200) {
            //console.log(lyricJson.lrc.lyric);
            songMassge.Lyrics = lyricJson.lrc.lyric ? parseLyric(lyricJson.lrc.lyric) : [];
        }
    } catch(err) {
        console.error(err);
        return Promise.reject(err);
    }

    let songUrl = songPlayUrl + '?id=' + hash;
    let songResponse = await urlFetch(songUrl);
    try {
        let songJson = await songResponse.json();

        if(songJson.code === 200) {
            songMassge.PlayUrl = songJson.data[0].url;
        }
        if(!songMassge.PlayUrl) {
            return Promise.reject('该歌曲已经下架！');
        }else{
            songMassge.PlayUrl = getPlayUrl(hash);
        }
    } catch(err) {
        console.error(err);
        return Promise.reject(err);
    }

    return songMassge;
}

let singersName = function(arr) {
    let singers = '';
    for (let index = 0; index < arr.length; index++) {
        singers += arr[index].name;
        singers += (index === arr.length - 1 ? '' : '、');
    }
    return singers;
}

let getPlayUrl = function(id) {
    let playUrl = 'http://music.163.com/song/media/outer/url?id=' + id + '.mp3';
    return playUrl;
}

export { getNeteaseHotSongList, getNeteaseSongMassge, getNeteaseSearchSongList }


// WEBPACK FOOTER //
// ./src/datasrc/Netease.js